var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWelcomeBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1260,
    height: 641,
    viewBox: "0 0 1260 641",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M126 611L129.241 619.759L138 623L129.241 626.241L126 635L122.759 626.241L114 623L122.759 619.759L126 611Z",
    fill: "#F2F6FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M245 417L241.219 427.219L231 431L241.219 434.781L245 445L248.781 434.781L259 431L248.781 427.219L245 417Z",
    fill: "#F2F6FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1076 21L1072.22 31.2187L1062 35L1072.22 38.7813L1076 49L1079.78 38.7813L1090 35L1079.78 31.2187L1076 21Z",
    fill: "#F2F6FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 393L5.83927 398.839L0 401L5.83927 403.161L8 409L10.1607 403.161L16 401L10.1607 398.839L8 393Z",
    fill: "#F2F6FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1031 564L1027.76 572.759L1019 576L1027.76 579.241L1031 588L1034.24 579.241L1043 576L1034.24 572.759L1031 564Z",
    fill: "#F2F6FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M138 33L134.759 41.7589L126 45L134.759 48.2411L138 57L141.241 48.2411L150 45L141.241 41.7589L138 33Z",
    fill: "#F2F6FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M526 457L522.759 465.759L514 469L522.759 472.241L526 481L529.241 472.241L538 469L529.241 465.759L526 457Z",
    fill: "#F2F6FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M444 605L440.759 613.759L432 617L440.759 620.241L444 629L447.241 620.241L456 617L447.241 613.759L444 605Z",
    fill: "#F2F6FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M854 45L850.219 55.2187L840 59L850.219 62.7813L854 73L857.781 62.7813L868 59L857.781 55.2187L854 45Z",
    fill: "#F2F6FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1246 128L1242.22 138.219L1232 142L1242.22 145.781L1246 156L1249.78 145.781L1260 142L1249.78 138.219L1246 128Z",
    fill: "#F2F6FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M493 0L487.328 15.3281L472 21L487.328 26.6719L493 42L498.672 26.6719L514 21L498.672 15.3281L493 0Z",
    fill: "#F2F6FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M646 156L642.219 166.219L632 170L642.219 173.781L646 184L649.781 173.781L660 170L649.781 166.219L646 156Z",
    fill: "#F2F6FF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1094 409L1096.16 414.839L1102 417L1096.16 419.161L1094 425L1091.84 419.161L1086 417L1091.84 414.839L1094 409Z",
    fill: "#F2F6FF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M231 184L235.862 197.138L249 202L235.862 206.862L231 220L226.138 206.862L213 202L226.138 197.138L231 184Z",
    fill: "#F2F6FF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M767 558L771.862 571.138L785 576L771.862 580.862L767 594L762.138 580.862L749 576L762.138 571.138L767 558Z",
    fill: "#F2F6FF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1215 605L1219.86 618.138L1233 623L1219.86 627.862L1215 641L1210.14 627.862L1197 623L1210.14 618.138L1215 605Z",
    fill: "#F2F6FF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1179 272L1183.86 285.138L1197 290L1183.86 294.862L1179 308L1174.14 294.862L1161 290L1174.14 285.138L1179 272Z",
    fill: "#F2F6FF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M659.999 359.19C734.732 346.967 869.873 337.987 928 334.5L928 341.5C797.56 345.342 693.951 355.283 659.999 359.19Z",
    fill: "#F2F6FF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M26 174L28.7009 181.299L36 184L28.7009 186.701L26 194L23.2991 186.701L16 184L23.2991 181.299L26 174Z",
    fill: "#F2F6FF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M923 359L928.402 344.402L943 339L928.402 333.598L923 319L917.598 333.598L903 339L917.598 344.402L923 359Z",
    fill: "#225AEA"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcomeBg);
export default __webpack_public_path__ + "static/media/welcome-bg.09c2cbe5dc5010e98590aa23e162518f.svg";
export { ForwardRef as ReactComponent };